import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, watch, computed } from 'vue'

interface Props {
  to: number | string // 数据结束值
  from?: number // 数据起始值
  times?: number // 执行次数
  speed?: number // 每次执行时间
  decimals?: number // 小数点位数
  formatter?: (data: number) => number | string // 格式化回调
  complete?: (data: number) => unknown // 完成后触发
  update?: (data: number) => unknown // 更新时触发
}


export default /*#__PURE__*/_defineComponent({
  ...{ name: 'WidgetCount' },
  __name: 'widget-count',
  props: {
    to: { default: 1000 },
    from: { default: 0 },
    times: { default: 36 },
    speed: { default: 60 },
    decimals: { default: 0 },
    formatter: {},
    complete: {},
    update: {}
  },
  setup(__props: any) {

const props = __props;



const end = computed(() => (typeof props.to === 'number' ? props.to : parseFloat(props.to)))
const count = ref(0) // 相加数值
const timer = ref(0) // 计时器编号
const start = computed(() => (typeof props.from === 'number' ? props.from : parseFloat(props.from)))
const minus = computed(() => (end.value - start.value) / props.times) // 每次增加步数
const power = computed(() => Math.pow(10, props.decimals))
const content = ref() // 显示数值

// 初始化动画
const initAnimate = () => {
  count.value = start.value
  if (end.value < props.times) return (content.value = end.value)
  if (timer.value) clearInterval(timer.value)
  timer.value = setInterval(refreshDigital, props.speed)
}

// 更新数据值
const refreshDigital = () => {
  const number = count.value + minus.value
  const result = Math.round(number * power.value) / power.value

  count.value = number
  content.value = props.formatter ? props.formatter(result) : result
  props.update && props.update(result)

  if (count.value >= end.value) {
    content.value = props.formatter ? props.formatter(end.value) : end.value
    clearInterval(timer.value)
    props.complete && props.complete(result)
  }
}

watch(
  () => props.to,
  (now, old) => now !== old && initAnimate(),
  { immediate: true }
)



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, _toDisplayString(content.value), 1))
}
}

})